"use client";

import { Dialog, DialogContent, DialogFooter } from "@/components/ui/dialog";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

interface NotificationBlockedDialogProps {
    open: boolean;
    onAccept: () => void;
}

const NotificationBlockedDialog: React.FC<NotificationBlockedDialogProps> = ({
    open,
    onAccept,
}) => {
    return (
        <Dialog open={open}>
            <DialogContent className="w-[80%] !rounded-xl md:max-w-md [&>button:last-child]:hidden">
                <div className="flex flex-col gap-1 md:gap-3">
                    <h2 className="text-base font-semibold md:text-xl">Enable Notifications</h2>
                    <p className="text-sm text-muted-foreground md:text-base">
                        You have blocked notifications for this site. Please enable them from your
                        browser settings if you wish to receive updates.
                    </p>
                </div>
                <DialogFooter className="flex flex-col items-center justify-center">
                    <RegularButton
                        variant={ButtonVariant.PrimaryDefault}
                        size={ButtonSize.Medium}
                        label="Ok"
                        onClick={onAccept}
                        noIcon={true}
                        showRightIcon={false}
                    />
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default NotificationBlockedDialog;
